/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PostCreateFailData model module.
 * @module model/PostCreateFailData
 * @version 1.0
 */
class PostCreateFailData {
    /**
     * Constructs a new <code>PostCreateFailData</code>.
     * @alias module:model/PostCreateFailData
     */
    constructor() { 
        
        PostCreateFailData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PostCreateFailData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PostCreateFailData} obj Optional instance to populate.
     * @return {module:model/PostCreateFailData} The populated <code>PostCreateFailData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PostCreateFailData();

            if (data.hasOwnProperty('row')) {
                obj['row'] = ApiClient.convertToType(data['row'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PostCreateFailData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PostCreateFailData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }

        return true;
    }


}



/**
 * @member {Number} row
 */
PostCreateFailData.prototype['row'] = undefined;

/**
 * @member {Number} accountNo
 */
PostCreateFailData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
PostCreateFailData.prototype['email'] = undefined;






export default PostCreateFailData;

